var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-adv"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":_vm.advConfig.url}},[_c('img',{attrs:{"src":_vm._f("urlFilter")(_vm.advConfig.img),"alt":""}}),_c('span',{staticClass:"close iconfont icon-guanbi1",on:{"click":function($event){$event.preventDefault();_vm.$parent.isPopAdv = false}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }